import * as React from "react";
import { useState, useEffect } from "react";
import Stack from "@mui/material/Stack";
import AddIcon from "@mui/icons-material/Add";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { 
  Box, Button, Grid, MenuItem, Select, Radio, RadioGroup, 
  FormControlLabel, FormControl, FormGroup, Checkbox, TextField,
  Card, CardContent, Divider, CircularProgress
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import DatePicker from "../../../Components/DatePicker";
import { LeadAgentsSettingsApi, departmentHRApi } from "../../../Data/axios";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AssignBulkShifts({ open, onClose }) {
  const [departmnet, setDepartment] = React.useState("");
  const [employees, setEmployees] = React.useState("");
  const [employeeShift, setEmployeeShift] = React.useState("");
  const [shiftby, setShiftby] = React.useState("date");
  const [date, setDate] = React.useState(null);
  const [employeesError, setEmployeesError] = React.useState(false);
  const [remark, setRemark] = useState("");
  const [fileName, setFileName] = useState("");
  const [departments, setDepartments] = useState([]);
  const [loadingDepartments, setLoadingDepartments] = useState(false);
  const [apiEmployees, setApiEmployees] = useState([]);
  const [loadingEmployees, setLoadingEmployees] = useState(false);

  // Fetch departments from the API
  useEffect(() => {
    if (open) {
      fetchDepartments();
      fetchEmployees();
    }
  }, [open]);

  const fetchDepartments = async () => {
    setLoadingDepartments(true);
    try {
      const response = await departmentHRApi.getAll();
      if (response && response.data) {
        setDepartments(response.data);
      } else {
        console.error("No departments found or empty response");
        setDepartments([]);
      }
    } catch (error) {
      console.error("Error fetching departments:", error);
    } finally {
      setLoadingDepartments(false);
    }
  };

  // Fetch employees from the API
  const fetchEmployees = async () => {
    setLoadingEmployees(true);
    try {
      const response = await LeadAgentsSettingsApi.getEmployee();
      if (response) {
        setApiEmployees(response);
      } else {
        setApiEmployees([]);
      }
    } catch (error) {
      console.error("Error fetching employees:", error);
    } finally {
      setLoadingEmployees(false);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFileName(file.name);
    console.log(file.name);
  };

  const handleDateChange = (newDate) => {
    setDate(newDate);
    console.log(newDate);
  };

  const handleSave = () => {
    const list = {
      departmnet,
      employees,
      employeeShift,
      date,
      shiftby,
      remark,
      fileName,
    };
    console.log(list);
    if (employees === "") {
      setEmployeesError(true);
    } else {
      setEmployeesError(false);
      onClose(); // Use the onClose prop to close the dialog
    }
  };

  // Define reusable input styling to match Department style
  const inputProps = {
    sx: {
      bgcolor: "#f9f9f9",
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "#e0e0e0",
        },
        "&:hover fieldset": {
          borderColor: "#bdbdbd",
        },
      },
      "& .MuiSelect-select": {
        color: "#424242", // For dropdown selects
      },
      "& .MuiInputBase-input": {
        color: "#424242", // For text and date inputs
      },
    },
  };

  const checkboxStyle = {
    color: "#9e9e9e",
    "&.Mui-checked": {
      color: "#4285F4",
    },
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth
        maxWidth="md"
        open={open}
        onClose={onClose}
        TransitionComponent={Transition}
        PaperProps={{
          style: {
            position: "absolute",
            top: 0,
            right: 0,
            width: "calc(100% - 260px)",
            height: "100%",
            backgroundColor: "#f5f5f5",
            margin: 0,
            maxHeight: "100%",
            borderRadius: 0,
            overflowX: "hidden",
            zIndex: 1200,
          },
        }}
      >
        <AppBar sx={{ position: "relative", bgcolor: "#ffffff", boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={onClose}
              aria-label="close"
              sx={{ color: "#212121" }}
            >
              <CloseIcon fontSize="large" />
            </IconButton>
            <Typography
              sx={{ ml: 2, flex: 1, fontSize: "18px", color: "#212121" }}
              component="div"
            >
              Assign Bulk Shifts
            </Typography>
          </Toolbar>
        </AppBar>
        <Box sx={{ background: "#f5f5f5", p: 4, overflowY: "auto" }}>
          <Card sx={{ p: 2, bgcolor: "#ffffff", boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.08)" }}>
            <CardContent>
              <Typography variant="h6" sx={{ color: "#212121", mb: 3 }}>
                Add Shift Roaster
              </Typography>
              <Divider sx={{ mb: 3 }} />
              
              <Box sx={{ 
                bgcolor: "#e3f2fd", 
                p: 2, 
                borderRadius: "4px", 
                display: "flex", 
                alignItems: "center", 
                mb: 3 
              }}>
                <InfoIcon sx={{ color: "#1976d2", mr: 1 }} />
                <Typography variant="body2" sx={{ color: "#0d47a1" }}>
                  This existing shift will be overridden
                </Typography>
              </Box>

              <Grid container spacing={3}>
                {/* Department dropdown with API data */}
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                    Department
                  </Typography>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    value={departmnet}
                    onChange={(e) => setDepartment(e.target.value)}
                    InputProps={inputProps}
                    disabled={loadingDepartments}
                  >
                    <MenuItem value="">
                      <em>---</em>
                    </MenuItem>
                    {loadingDepartments ? (
                      <MenuItem disabled>
                        <Box display="flex" alignItems="center" gap={1}>
                          <CircularProgress size={20} />
                          <span>Loading departments...</span>
                        </Box>
                      </MenuItem>
                    ) : (
                      departments.map((department) => (
                        <MenuItem key={department.id} value={department.department}>
                          {department.department}
                        </MenuItem>
                      ))
                    )
                    }
                  </TextField>
                </Grid>
                
                {/* Employee dropdown with API data */}
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                    Employee <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    value={employees}
                    onChange={(e) => setEmployees(e.target.value)}
                    InputProps={inputProps}
                    error={employeesError}
                    helperText={employeesError ? "Please select an employee" : ""}
                    disabled={loadingEmployees}
                  >
                    <MenuItem value="">
                      <em>---</em>
                    </MenuItem>
                    {loadingEmployees ? (
                      <MenuItem disabled>
                        <Box display="flex" alignItems="center" gap={1}>
                          <CircularProgress size={20} />
                          <span>Loading employees...</span>
                        </Box>
                      </MenuItem>
                    ) : (
                      apiEmployees.map((employee) => (
                        <MenuItem key={employee.id} value={employee.id}>
                          <Box display="flex" justifyContent="space-between" width="100%">
                            <span>{employee.name}</span>
                            <Typography variant="caption" color="text.secondary">
                              {employee.empid}
                            </Typography>
                          </Box>
                        </MenuItem>
                      ))
                    )}
                  </TextField>
                </Grid>
                
                {/* Employee Shift */}
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                    Employee Shift
                  </Typography>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    value={employeeShift}
                    onChange={(e) => setEmployeeShift(e.target.value)}
                    InputProps={inputProps}
                  >
                    <MenuItem value="">
                      <em>---</em>
                    </MenuItem>
                    <MenuItem value="Day Off">Day Off</MenuItem>
                    <MenuItem value="General Shift [11:30:00-20:30:00]">General Shift [11:30:00-20:30:00]</MenuItem>
                  </TextField>
                </Grid>
                
                {/* Assign Shift By */}
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                    Assign Shift By
                  </Typography>
                  <FormControl component="fieldset">
                    <RadioGroup
                      row
                      value={shiftby}
                      onChange={(e) => setShiftby(e.target.value)}
                    >
                      <FormControlLabel
                        value="date"
                        control={<Radio sx={{ 
                          color: "#bdbdbd",
                          '&.Mui-checked': {
                            color: "#4285F4",
                          },
                        }} />}
                        label="Date"
                        sx={{ color: "#616161" }}
                      />
                      <FormControlLabel
                        value="multiple"
                        control={<Radio sx={{ 
                          color: "#bdbdbd",
                          '&.Mui-checked': {
                            color: "#4285F4",
                          },
                        }} />}
                        label="Multiple"
                        sx={{ color: "#616161" }}
                      />
                      <FormControlLabel
                        value="month"
                        control={<Radio sx={{ 
                          color: "#bdbdbd",
                          '&.Mui-checked': {
                            color: "#4285F4",
                          },
                        }} />}
                        label="Month"
                        sx={{ color: "#616161" }}
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                
                {/* Date Picker */}
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                    You can select Multiple Date
                  </Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={date}
                      onChange={handleDateChange}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          size: "small",
                          InputProps: inputProps
                        }
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
                
                {/* Send Email Option */}
                <Grid item xs={12}>
                  <FormControlLabel
                    control={<Checkbox sx={checkboxStyle} defaultChecked />}
                    label="Send Email"
                    sx={{ color: "#616161" }}
                  />
                </Grid>
                
                {/* Remarks */}
                <Grid item xs={12}>
                  <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                    Remark
                  </Typography>
                  <TextField
                    multiline
                    rows={4}
                    fullWidth
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                    InputProps={inputProps}
                  />
                </Grid>
                
                {/* File Upload */}
                <Grid item xs={12}>
                  <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                    Add file
                  </Typography>
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                  }}>
                    <label
                      htmlFor="file-upload"
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        padding: "12px",
                        backgroundColor: "#f9f9f9",
                        border: "1px solid #e0e0e0",
                        borderRadius: "4px",
                        color: "#424242",
                      }}
                    >
                      Upload File
                    </label>
                    <input
                      onChange={handleFileChange}
                      type="file"
                      id="file-upload"
                      style={{ display: "none" }}
                    />
                  </Box>
                  {fileName && (
                    <Typography variant="caption" sx={{ color: "#4285F4", mt: 1 }}>
                      {fileName}
                    </Typography>
                  )}
                </Grid>
              </Grid>

              <Box display="flex" gap={2} mt={3}>
                <Button
                  onClick={handleSave}
                  variant="contained"
                  sx={{
                    bgcolor: "#4285F4",
                    color: "white",
                    "&:hover": { bgcolor: "#3367D6" },
                    fontWeight: 500,
                    textTransform: "none",
                    padding: "8px 16px",
                  }}
                >
                  Save
                </Button>
                <Button
                  onClick={onClose}
                  variant="outlined"
                  sx={{
                    borderColor: "#bdbdbd",
                    color: "#424242",
                    "&:hover": {
                      borderColor: "#9e9e9e",
                      bgcolor: "rgba(0, 0, 0, 0.04)",
                    },
                    textTransform: "none",
                    padding: "8px 16px",
                  }}
                >
                  Cancel
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Box>
      </Dialog>
    </React.Fragment>
  );
}
